import React, { useState } from 'react';
import { renameCrop } from '../../services/mycrops/myCropsService';

// Mismo formato que el modal de editar sensor (SensorEditModal)
const CropRenameModal = ({ crop, onClose, onRenamed }) => {
    const [name, setName] = useState(crop.name || '');
    const [saving, setSaving] = useState(false);

    const handleSave = async (event) => {
        event.preventDefault();
        const trimmed = name.trim();
        if (!trimmed) {
            alert('El nombre es obligatorio.');
            return;
        }
        setSaving(true);
        try {
            await renameCrop(crop.id, trimmed);
            onRenamed(trimmed);
            onClose();
        } catch (error) {
            console.error('Error al cambiar el nombre del cultivo: ', error);
            alert(error.response?.data?.message || 'No se pudo cambiar el nombre, intenta de nuevo.');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="flex fixed inset-0 z-50 items-center justify-center p-4 bg-gray-900 bg-opacity-80">
            <div className="w-full max-w-md bg-white shadow-lg rounded">
                <div className="relative flex items-center p-4 text-black">
                    <h2 className="text-xl font-semibold">Modificar <span className="text-blue-600">{crop.name}</span></h2>
                    <button type="button" onClick={onClose} className="absolute top-0 right-0 mt-4 mr-4 hover:text-red-500 w-6 h-6">
                        <span className="material-icons text-2xl font-bold">close</span>
                    </button>
                </div>

                <div className="px-4 text-black h-auto overflow-y-auto">
                    <form onSubmit={handleSave} className="flex flex-col items-center space-y-3 pb-2">
                        <div className='w-full'>
                            <label htmlFor="cropName" className="block font-semibold text-black mb-1"> Nombre del cultivo <span className="text-red-500">*</span></label>
                            <input id="cropName" type="text" autoComplete="off" autoFocus maxLength={100}
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder="Nombre del cultivo"
                                className="block w-full p-2 bg-white border border-gray-200 text-black text-sm focus:outline-none focus:ring-2 focus:ring-blue-600 rounded"
                            />
                        </div>

                        <div className="flex items-center justify-center space-x-4">
                            <div className="w-full">
                                <button type="submit" disabled={saving} className="flex flex-1 rounded w-full justify-center text-white bg-blue-600 hover:bg-blue-800 disabled:opacity-60 font-medium px-5 py-2.5 me-2 mb-2 transition duration-200">
                                    <span className="material-icons mr-2">save</span>Guardar
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CropRenameModal;
